import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class ConstantsModule {
  API_URL = 'https://gdpms.mowr.gov.in/api/'; 
 API_URL_GEC = "https://indiagec.vassarlabs.com/staging/api/";
 API_URL_USER ='https://gdpms.mowr.gov.in/user/';
// API_URL_USER ='http://localhost:9001/';
 API_USER ='http://gdpms.vassarlabs.com/user/';  
  API_URL_SHAPEFILE = 'http://gdpms.vassarlabs.com/';
   DEBUGGER = false;
   DEFAULT_COUNTRY = "INDIA";
   COUNTRYUUID = "ffce954d-24e1-494b-ba7e-0931d8ad6085";
   DEFAULT_STATE = "Andhra Pradesh";
  VERSIONKEY = '1111100000';
  REGIONKEY = "20d5931b-d962-4b4f-9fde-08d9db3db3e8"
  PASSWORD_STANDARD = "Password should contain atleast one upper case alphabet,one lower case alphabet,one digit,one special character and atleast 8 characters and at most 20 characters";
  PUBLIC_KEY = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCuDEWABVXfJ9se3bqfYC7zPnMjmivjb7XbvfIJiQEosQ48Iws6kMfAsPyu1aHiI1PSy0PvpXR08ZNyUKzTdqb3BZ7tIprSRPtGZKV9hoWQEcSL7w+Og6j1pmvlT5vxMbnDrzlbvV6EDG11I9CFULWw2w4yQD2vm9z7KSAN9eawUwIDAQAB";
  PRIVATE_KEY = "MIICeQIBADANBgkqhkiG9w0BAQEFAASCAmMwggJfAgEAAoGBAK4MRYAFVd8n2x7dup9gLvM+cyOaK+Nvtdu98gmJASixDjwjCzqQx8Cw/K7VoeIjU9LLQ++ldHTxk3JQrNN2pvcFnu0imtJE+0ZkpX2GhZARxIvvD46DqPWma+VPm/ExucOvOVu9XoQMbXUj0IVQtbDbDjJAPa+b3PspIA315rBTAgMBAAECgYEApHCFrYnc8wT1+vik3PWEBl+nayi7dJvT53RT3Hxr8uUtvNWjQ0cM41qUsh63Xy/ff5Z6bk4VdHPVyji8wOImpkJntjHG95Oxrk/KNB3FC6hgpLHv7LUDE8B+S480OYGPGW8YEHa9Xc3a+D4eE5N3xWfm1pIR31nY/vJjiFzAyPkCQQD5Wgafl54eu2v6tm/kA4StDraPJV1CjPr5BhPA851ZpryZWlR71m7X6ZEbeqZ/hcoILPaTZt34CZhma+BIdVmvAkEAsrBArobZ02o8OFwcmw6b/lP7yhfATlYTxm54w5utZqGYaxJRXMUZxuMygxPCBt3+soOzteZlTWolBgsihphQnQJBAMxNr/mZH8wsYke0rS7UlyO4V2ooAiaiHoxlJ1BECtvG2uaHdYtV4dH0pJkwQDViKGvUc1/Iu/wb2IuqvcSAqi8CQQCRZRTcbeGkQxcJDPpBuNt5UEDaqgTSOPwSRCWDlJK9pdNtnBQUFlTpHkklmtgP2ma6Pqvl4LihCzNg/YJ0Xk+JAkEA35OqpPXO7Bbbx6EWhPnBmCQAj9N4Xg/kiLpC5v/yHIBtGdWC5yZLpc5vywPpJ6GaltxcoIPPAdWXO/rdWm5+TQ==";
  COMPONENT = {
   "ACTUAL_DATA" : 1,
    "COMPUTED_DATA" : 2,
    "WEIGHTS_DATA" : 3,
    "AGGREGATED_DATA":5
  }
  DATEPICKER_DATE_FORMAT = {
    YEAR: 'yyyy',
    MONTH: 'yyyyMM',
    DAY: 'yyyyMMdd'
  };
  HISTORY_DATA_OBJ = {
    "TARGET" : 3
  }
  DATA_QUATERLY_OBJ = {
    "QUATERLY_DATA":"Q1",
    "QUATERLY_DATA1":"Q2",
    "QUATERLY_DATA2" :"Q3",
    "QUATERLY_DATA3" : "Q4"
  }
  AGGREGATED_LIST = {
    SIMPLE_AVERAGE : 6,
    WEIGHTED_AVERAGE : 7
  }


  OFFICIALS_LIST ={
    "districtcollector(chairperson)" : "District Collector(Chairperson)",
    "representativefrommunicipalities" : "Representative from municipalities",
    "representativefromgrampanchayats": "Representative from gram panchayats",
    "representativefrompublicworks": "Representative from Public Works",
    "representativefromirrigation": "Representative from Irrigation",
    "representativefrompublichealth Engineering": "Representative from Public Health Engineering",
    "representativefromruraldrinkingwaterdepartment": "Representative from Rural Drinking Water Department",
    "representativefromstatepollutioncontrolboard": "Representative from State Pollution Control Board",
    "environmentalistsassociatedwithrivergangaprotection": "Environmentalists associated with River Ganga protection",
    "representativeoflocalindustry":"Representative of local industry",
    "divisionalforestofficer(memberconvenor)":"Divisional Forest Officer(Member Convenor)"
  }
  GENDER_LIST ={
    "male" : "Male",
    "female" : "Female",
    "other" : "Other"
  }
  ATTENDANCE_LIST = {
    "yes" : "Yes",
    "no" : "No"
  }

  CURRENT_NEXT_MAPPING = {
    "1a91d3a6-44f0-462b-b9bc-c9db3c908890": "e237269e-7e90-4eb7-a988-652ebba3588f",
    "e237269e-7e90-4eb7-a988-652ebba3588f": "63837b7a-fd49-4fa0-890b-d7010c7b4491",
    "63837b7a-fd49-4fa0-890b-d7010c7b4491": "91f13165-ec5b-418a-a76c-8d1ddd2f3405",
    "91f13165-ec5b-418a-a76c-8d1ddd2f3405": "5a809e2a-f7a0-40be-9272-edf01e41ca83",
    "5a809e2a-f7a0-40be-9272-edf01e41ca83": "06780eb6-c1c8-4bc0-a8e5-1112d80091b9",
    "06780eb6-c1c8-4bc0-a8e5-1112d80091b9": "7ff91046-3395-4d61-a8ce-e3e9e4f4570c",
    "7ff91046-3395-4d61-a8ce-e3e9e4f4570c": "9f9618fa-3c04-49c2-9e9a-bed5c6a35ce7",
    "9f9618fa-3c04-49c2-9e9a-bed5c6a35ce7": "8305ab10-8d85-468e-947b-8d402da923d0",
    "8305ab10-8d85-468e-947b-8d402da923d0": "2062c000-3d02-4cae-b5b6-64e26f64fba8",
    "2062c000-3d02-4cae-b5b6-64e26f64fba8": "f192f6a4-f543-4a97-9a1c-1bf68c752e74",
    "f192f6a4-f543-4a97-9a1c-1bf68c752e74": "2d975382-1910-41a6-8762-7638570ef59d",
    "2d975382-1910-41a6-8762-7638570ef59d": "635897d2-1617-424b-9848-e39c022f1834",
    "635897d2-1617-424b-9848-e39c022f1834": "aff6273a-fd36-458a-9b99-5758f5278edd",
    "aff6273a-fd36-458a-9b99-5758f5278edd": "e985bfe9-adcb-4604-800e-93cbb8e263f1",
    "e985bfe9-adcb-4604-800e-93cbb8e263f1": "68bf64e4-abd0-4f01-ba99-7105b8355596",
    "68bf64e4-abd0-4f01-ba99-7105b8355596": "ac48028b-1eaf-4344-b291-4c4374a216a9",
    "ac48028b-1eaf-4344-b291-4c4374a216a9": "8329b2a7-0b84-4ccc-b50a-9b63aa506e7b",
    "8329b2a7-0b84-4ccc-b50a-9b63aa506e7b": "26347cc5-23b0-4f6f-b962-95ecd7be8544",
    "26347cc5-23b0-4f6f-b962-95ecd7be8544": "9a4ea092-6468-46cf-bf53-20e75e712743",
    "9a4ea092-6468-46cf-bf53-20e75e712743": "46bdc592-a541-4575-8849-71b0e3e03e02",
    "46bdc592-a541-4575-8849-71b0e3e03e02": "8e96272c-da0b-4e5e-b157-bab826dd656d",
    "8e96272c-da0b-4e5e-b157-bab826dd656d": "087b3de1-d1d4-4079-9fa3-6b2c57d693dd",
    "087b3de1-d1d4-4079-9fa3-6b2c57d693dd": "15e13bae-7df1-4f52-8c83-434e0212c2e7",
    "15e13bae-7df1-4f52-8c83-434e0212c2e7": "547911e6-f2ca-4201-9772-6b8c907607fa",
    "547911e6-f2ca-4201-9772-6b8c907607fa": "fb4902c3-00d9-4d49-bc2c-4013faa33fa6",
    "fb4902c3-00d9-4d49-bc2c-4013faa33fa6": "4c8fbb97-dce6-42e8-9a49-7e9928ccd001",
    "4c8fbb97-dce6-42e8-9a49-7e9928ccd001": "e6dcac2e-86de-4026-b314-0f2e32ba908a",
    "e6dcac2e-86de-4026-b314-0f2e32ba908a": "9cc78229-8d89-4877-afe5-263afe7c6fda",
    "9cc78229-8d89-4877-afe5-263afe7c6fda": "cd74620d-368b-4857-9267-6898c120a854",
    "cd74620d-368b-4857-9267-6898c120a854": "16af077d-cdc0-4b2a-a747-ecf0fd565fd6",
    "16af077d-cdc0-4b2a-a747-ecf0fd565fd6": "e78ddb62-199f-45dc-863f-9e47e5332142",
    "e78ddb62-199f-45dc-863f-9e47e5332142": "1c4ced52-e6b7-46f0-9c5d-c6c0fbb0bb63",
    "1c4ced52-e6b7-46f0-9c5d-c6c0fbb0bb63": "4e70114f-fdd2-4175-9fc2-2c1a27bf6992",
    "4e70114f-fdd2-4175-9fc2-2c1a27bf6992": "584aff29-c5be-4b33-bc97-a6c3f0165f8b",
    "584aff29-c5be-4b33-bc97-a6c3f0165f8b": "29287c3d-5f77-4945-9707-1116d8bda775",
    "29287c3d-5f77-4945-9707-1116d8bda775": "9450088e-0991-4b00-8c44-2434c15f1bc6",
    "9450088e-0991-4b00-8c44-2434c15f1bc6": "b259c8e1-556d-41f9-994e-2e7b3fafc8b3",
    "b259c8e1-556d-41f9-994e-2e7b3fafc8b3": "1188bda9-e5cd-4d41-8e59-2fda5cbfff01",
    "1188bda9-e5cd-4d41-8e59-2fda5cbfff01": "3a120b7f-1bf6-4c22-b5fe-8f4b852f1a55",
    "3a120b7f-1bf6-4c22-b5fe-8f4b852f1a55": "e8bb7c15-1f35-4ff4-81d7-18590b6ffb96",
    "e8bb7c15-1f35-4ff4-81d7-18590b6ffb96": "0a720388-b93b-46ca-b482-160ec4e3f322",
    "0a720388-b93b-46ca-b482-160ec4e3f322": "fa2e3586-5b0c-42b2-a763-613364aaec30",
    "fa2e3586-5b0c-42b2-a763-613364aaec30": "a7906929-6808-42db-a7b2-30fd95980f1f",
    "a7906929-6808-42db-a7b2-30fd95980f1f": "bad776ff-fdee-4625-8fe8-0a40372090f7",
    "bad776ff-fdee-4625-8fe8-0a40372090f7": "1825a732-fdbd-4725-b930-0d8c2b085492",
    "1825a732-fdbd-4725-b930-0d8c2b085492": "cc02e40d-79b8-493a-b617-5fe8406c75cc",
    "cc02e40d-79b8-493a-b617-5fe8406c75cc": "80b10930-cc79-4876-af27-44c6c576c257",
    "80b10930-cc79-4876-af27-44c6c576c257": "d136f658-ec67-4920-ac67-d819d4f052b1",
    "d136f658-ec67-4920-ac67-d819d4f052b1": "1699ebaf-be34-45ee-b86e-90b0712a5d26",
    "1699ebaf-be34-45ee-b86e-90b0712a5d26": "869b2745-3c9a-438f-8a42-ebef5ce10d3b",
    "869b2745-3c9a-438f-8a42-ebef5ce10d3b": "acb0df4b-975e-4080-9c04-dd6405b01c0f",
    "acb0df4b-975e-4080-9c04-dd6405b01c0f": "da6c25e9-0d54-49cb-8e13-1445c189537c",
    "da6c25e9-0d54-49cb-8e13-1445c189537c": "eb1d88f3-a94f-4f82-ac99-82e5c2b8b667",
    "eb1d88f3-a94f-4f82-ac99-82e5c2b8b667": "33f5f6f2-ab37-4997-8a54-25ce66e913fb",
    "33f5f6f2-ab37-4997-8a54-25ce66e913fb": "4c3b8a65-6850-4f2e-99b4-df40b2ded196",
    "4c3b8a65-6850-4f2e-99b4-df40b2ded196": "b47be2e0-4536-43e6-9f9e-f890e6cf6219"
  }
  ACTION = {
   "approve" : "APPROVE",
   "reject" : "REJECT",
   "modify" : "MODIFY"
  }
  FILETYPE = {
    "report" : "Report",
    "indicator" : "Indicator",
    "indicators" : "Indicators"
  }
  ACTIONMSG = {
    "approve" : "approved",
    "reject" : "rejected"
   }
   ERRORACTIONMSG = {
    "approve" : "approving",
    "reject" : "rejecting"
   }
  ASS_UNIT_LIST ={
    list:["BLOCK",
    "ISLAND",],
    BLOCK:'Block',
    ISLAND:'Island'
  }
  LOCATION_CONSTANT = {
    COUNTRY : "COUNTRY",
    STATE : "STATE",
    DISTRICT : "DISTRICT",
    MANDAL : "MANDAL",
    BLOCK : "BLOCK",
    BASIN : "BASIN",
    SUBBASIN : "SUBBASIN",
    STATION : "STATION",
    REGION : "REGION"
  };
  GETLOTIONHIRUTOL = {
    COUNTRY : "STATE",
    STATE : "DISTRICT"
   };
  CATEGORY = {
    "SEMI_CRITICAL":"semi_critical",
    "OVER_EXPLOITED":"over_exploited"
  }
  USER_TYPES = {
    STATE_NODAL_OFFICER : "STATE_NODAL_OFFICER",
    VALIDATION_AGENCY : "VALIDATION_AGENCY",
    ADMIN : "ADMIN",
    DISTRICT_GANGA_COMMITTEE: "DISTRICT_GANGA_COMMITTEE",
    DISTRICT_VALIDATE_MEMBER : "DISTRICT_VALIDATE_MEMBER"

  }
  // COMPONENT_SOURCE_HIERARCHY_MAP = {
  //   [this.COMPONENT.RECHARGE] : {
  //     ADMIN : [this.LOCATION_CONSTANT.COUNTRY, this.LOCATION_CONSTANT.STATE, this.LOCATION_CONSTANT.DISTRICT,this.LOCATION_CONSTANT.STATION],
  //     BASIN : [this.LOCATION_CONSTANT.COUNTRY, this.LOCATION_CONSTANT.BASIN, this.LOCATION_CONSTANT.SUBBASIN,this.LOCATION_CONSTANT.STATION]
  //   }
  // };
  COLORMAPFORCHART = {
    'actual':'red',
    'normal': 'blue',
    'approved': 'green'
  }
  ROLEBASEDSIDETABMAP = {
    "STATE_GANGA_COMMITTEE" : ["meetingreport","uploadreport","statelistofDGCs","state-dgcreports","meeting-attendance-report"],
    "SUPER_ADMIN" : ["usermanagement"],
    "ADMIN":["summary","edit-weightage","dynamicindicator","usermanagement","triggercomputations","extensionapproval","aggregationadmin","meetingmodule","meetingstatus","broadcasting","mandatorythemes","adminlistofDGCs","admin-dgcreports","meeting-attendance-report"],
    "DISTRICT_VALIDATE_MEMBER" : ["approvals","weightage-edits","manualintervention","aggregationreports"],
    "STATE_NODAL_OFFICER" :["datasubmitapprovals","excelupload","exceldownload","forminput","shapefileupload","requestextension","extensionapproval",],
    // "DISTRICT_GANGA_COMMITTEE" : ["datasubmitapprovals","excelupload","exceldownload","forminput","requestextension"]
    "DISTRICT_GANGA_COMMITTEE" : ["datasubmitapprovals","uploadexcel","downloadexcel","forminput","requestextension","dgcmeetingreports","meeting-attendance-report"],
    "MISCELLANEOUS_USER" : ["meetingmodule","meetingstatus","admin-dgcreports","meeting-attendance-report"]
  };
 
  STATEUUIDLAYERNAME={
    'bd81d570-0e97-4dad-9bcd-219a05f56f2f':'NEWRM:indgec_chatis_mandal',
    'b967d23e-68c8-492c-a372-9623441f7d24':'NEWRM:indgec_meghalya',
    '648a95f6-9249-4c92-8ae4-a9d93eb7c898':'NEWRM:indgec_haryana',
    '785cc6f0-e9d0-4961-9578-08ed2f24377a': 'NEWRM:indgec_rajasthan',
    '94360caf-ebf0-4303-8c9e-3509bb0cded2':'NEWRM:indgec_assam'
    
  }
  STATEUUIDLAYERS={
    'bd81d570-0e97-4dad-9bcd-219a05f56f2f':'indgec_chatis_mandal',
    'b967d23e-68c8-492c-a372-9623441f7d24':'indgec_meghalya',
    '648a95f6-9249-4c92-8ae4-a9d93eb7c898':'indgec_haryana',
    '785cc6f0-e9d0-4961-9578-08ed2f24377a': 'indgec_rajasthan',
    '94360caf-ebf0-4303-8c9e-3509bb0cded2':'NEWRM:indgec_assam'
    
  }
  ROLEBASEDDEFAULTCOMP = {
    "STATE_GANGA_COMMITTEE" : "state-dgcreports",
    "SUPER_ADMIN" : "usermanagement",
    "ADMIN":"admin-dgcreports",
    "DISTRICT_VALIDATE_MEMBER" : "approvals",
    "STATE_NODAL_OFFICER" :"datasubmitapprovals",
    "DISTRICT_GANGA_COMMITTEE" : "forminput",
    "MISCELLANEOUS_USER" : "admin-dgcreports"
  }
  AREATYPE = [
    {id:'command' ,value:'Command'},
    {id:'non_command' ,value:'Non-Command'},
    {id:'poor_quality' ,value:'Poor Quality'},
    ]
    MAJORPARAMTER = ['Salinity','Fluoride','Arsenic'];
    AREATYPE2 = [
      {id:'command' ,value:'Command'},
      {id:'poor_quality' ,value:'Poor Quality'},
      ]
    SEASONTYPE =[
      {id:'monsoon',value:'monsoon'},
      {id:'non_monsoon',value:'non_monsoon'}
    ]
    TYPE = [
      {id:31 ,value:'domestic',format :'Domestic'},
      {id:33 ,value:'industry',format : 'Industry'},
      {id:35 ,value:'agriculture',format : 'Irrigation'},
      ]
  LOCATION_TYPES = ['country','state', 'district', 'mandal', 'block', 'village','basin','subbasin'];

  VIEWS = {
    admin: "admin",
    ADMIN : "ADMIN"
  };
  VIEWS_VERSION = {
    admin: "ADMIN",
    basin: "BASIN",
  };
  TYPE_SHAPEFILE = {
    primary: "Primary",
    basin: "Basin",
  }
  VIEW_SHAPEFILE ={
    ADMIN: "Admin",
    BASIN: "Basin",
  }
  RAINFALL_LIST={
    "Rf_Cummulative":  "RF CUMULATIVE",
    "Rf_Station":"RF STATION",
     "Rf_IMd" :  "RF IMD",
     "Rf_Timeseries":"RF TIMESERIES"
   }
   GROUNDWATER_LIST={
    "Gw_HistoryData" :"GW WELL HISTORY",
    "Gw_Station": "GW STATION",
    "Gw_Timeseries" : "GW TIMESERIES",
   }
  VERIFIED_REPORT = 1;
  UNVERIFIED_REPORT = 0;
  FIELD_ADMIN_VERIFIED = 2;
  DISTRICT_ADMIN_VERIFIED = 3;
  STATE_ADMIN_VERIFIED = 4;
  SLC_ADMIN_VERIFIED = 5;
  CGWB_ADMIN_VERIFIED = 6;
  CLEG_ADMIN_VERIFIED = 7;
  APPROVALLEVEL = {
    "GEC_CENTRAL_ADMIN":this.CLEG_ADMIN_VERIFIED,
    "GEC_STATE_ADMIN" : this.DISTRICT_ADMIN_VERIFIED,
    "GEC_DISTRICT_ADMIN" :this.FIELD_ADMIN_VERIFIED,
    "GEC_FIELD_ADMIN" :this.UNVERIFIED_REPORT,
    "GEC_CGWB_admin" : this.SLC_ADMIN_VERIFIED,
    "GEC_CLEG_admin" : this.CGWB_ADMIN_VERIFIED,
    "GEC_SLC_admin": this.STATE_ADMIN_VERIFIED,
  }
  GECUSERROLES ={
    GEC_FIELD_ADMIN : 'GEC_FIELD_ADMIN',
    GEC_DISTRICT_ADMIN : 'GEC_DISTRICT_ADMIN',
    GEC_STATE_ADMIN : 'GEC_STATE_ADMIN',
    GEC_CENTRAL_ADMIN : 'GEC_CENTRAL_ADMIN',
    GEC_CGWB_admin : 'GEC_CGWB_admin',
    GEC_CLEG_admin : 'GEC_CLEG_admin',
    GEC_SLC_admin: 'GEC_SLC_admin',
  }
  APPROVALCHARTMAP = {
    'labels' : {
      'total':'Total',
      'na':'Not started',
      'un':'In progress',
      'fov':'Field verified',
      'dv':'Waiting for state approval',
      'sv':'Waiting for central approval',
      'cv':'completed'
    },
    'backgroundcolor':{
      'total':'#FFFFFF',
      'na':'#FF0000',
       'un':'#1193d4',
       'fov' : '#508aeb',
       'dv':'#FF00FF',
       'sv':'#508aeb',
        'cv':'#02904b'
    }
  }
  ASSESSMENT_YEAR = ['2012-2013','2016-2017','2019-2020'];
  MAPPING_GW_RECHARGE_NAME={
    "rainfall":"Rainfall Recharge",
    "streamRecharge":"Stream Channel Recharge",
    "canal":"Canal Recharge",
    "surface_irrigation":"Surface Water Irrigation",
    "gw_irrigation":"Ground Water Irrigation",
    "artificial_structure":"Water Conversation Structures",
    "water_body":"Tanks And Ponds",
    "total":"Total"
  }
  MAPPING_CAT_TO_ACTUAL={
    "safe":"Safe",
    "semi_critical":"Semi Critical",
    "over_exploited":"Over Exploited",
    "critical":"Critical",
    "hilly_area":"Hilly Area",
    "none" : '-'
  }
  MAPPING_ACT={
    "poor_quality" :"Base Flows",
    "total" : "Evaporation",
    "non_command" : "Transpiration",
    "lateral_aquifer" : "Lateral Flows",
    "vertcal_aquifer" : "Vertical Flows",
    "command" : "Evapo Transpiration",
    "Source" : "Total",
  }
  UNITCONVET = {
    "BCM": 100000,
  };
  POPUP_NA_MAP = ['NA','N/A'];
  CHECKCATEGORY = ['none',''];
  STATE_EXTENT={
    "2b9beab2-1495-4f05-b4da-29761ebeb2ee": {
      "_southWest": {
        "lat": 12.622344,
        "lng": 76.76519
      },
      "_northEast": {
        "lat": 19.165632,
        "lng": 84.768582
      }
    },
    "64ed986d-99e1-4ff0-8ed3-f82b67998155": {  
      "_southWest": {
        "lat": 24.132958,
        "lng": 89.699724
      },
      "_northEast": {
        "lat": 27.952834,
        "lng": 96.018497
      }
    },
    "b6ac0a1a-28ef-4c96-a16d-f4898fc31360": {
      "_southWest": {
        "lat": 24.286947,
        "lng": 83.344181
      },
      "_northEast": {
        "lat": 27.518616,
        "lng": 88.298296
      }
    },
    "cc8ae528-4534-4b2d-977b-1b8b83b7a0c1": {
      "_southWest": {
        "lat": 30.665455,
        "lng": 76.703846
      },
      "_northEast": {
        "lat": 30.759959,
        "lng": 76.841473
      }
    },
    "bd81d570-0e97-4dad-9bcd-219a05f56f2f": {
      "_southWest": {
        "lat": 17.793474,
        "lng": 80.246826
      },
      "_northEast": {
        "lat": 24.098851,
        "lng": 84.383844
      }
    },
    "ea8bbb08-07a7-40c5-b1f1-6f30a5425f22": {
      "_southWest": {
        "lat": 28.403052,
        "lng": 76.842514
      },
      "_northEast": {
        "lat": 28.861519,
        "lng": 77.347652
      }
    },
    "b0e4512e-f150-4b94-9a80-4af74ee0cbe9": {
      "_southWest": {
        "lat": 20.120943,
        "lng": 68.197082
      },
      "_northEast": {
        "lat": 24.708482,
        "lng": 74.460555
      }
    },
    "648a95f6-9249-4c92-8ae4-a9d93eb7c898": {
      "_southWest": {
        "lat": 27.651763,
        "lng": 74.481237
      },
      "_northEast": {
        "lat": 30.926706,
        "lng": 77.588007
      }
    },
    "d1452538-53ce-44ae-8224-ce7fa5cee82e": {
      "_southWest": {
        "lat": 30.379625,
        "lng": 75.593644
      },
      "_northEast": {
        "lat": 33.253539,
        "lng": 79.011757
      }
    },
    "636cefc6-067c-4e8c-961c-022f447fb2c7": {
      "_southWest": {
        "lat": 32.275538,
        "lng": 72.531066
      },
      "_northEast": {
        "lat": 37.07785,
        "lng": 80.328644
      }
    },
    "eb0206ea-3cd2-4fb1-a076-0d9987aaa9e7": {
      "_southWest": {
        "lat": 21.9708,
        "lng": 83.331271
      },
      "_northEast": {
        "lat": 25.348818,
        "lng": 87.978575
      }
    },
    "29548629-e5c0-46b2-88f2-df2a9accfd46": {
      "_southWest": {
        "lat": 21.075265,
        "lng": 74.040703
      },
      "_northEast": {
        "lat": 26.868535,
        "lng": 82.815532
      }
    },
    "27613679-4f3a-4f84-bacd-373e0ecd3219": {
      "_southWest": {
        "lat": 15.606794,
        "lng": 72.650448
      },
      "_northEast": {
        "lat": 22.006992,
        "lng": 80.899466
      }
    },
    "b967d23e-68c8-492c-a372-9623441f7d24": {
      "_southWest": {
        "lat": 25.02952,
        "lng": 89.818548
      },
      "_northEast": {
        "lat": 26.11752,
        "lng": 92.80471
      }
    },
    "fad63e29-1ee0-48fc-be22-210a45a0dc46": {
      "_southWest": {
        "lat": 17.814286,
        "lng": 81.393506
      },
      "_northEast": {
        "lat": 22.566854,
        "lng": 87.490202
      }
    },
    "b9973b48-0984-49b2-8c46-b5496eb6e35b": {
      "_southWest": {
        "lat": 29.543882,
        "lng": 73.885397
      },
      "_northEast": {
        "lat": 32.57603,
        "lng": 76.942968
      }
    },
    "785cc6f0-e9d0-4961-9578-08ed2f24377a": {
      "_southWest": {
        "lat": 23.060464,
        "lng": 69.484365
      },
      "_northEast": {
        "lat": 30.196434,
        "lng": 78.270755
      }
    },
    "10954bb4-e53f-4fe7-aa75-e33fe1c54945": {
      "_southWest": {
        "lat": 27.081327,
        "lng": 88.016857
      },
      "_northEast": {
        "lat": 28.130679,
        "lng": 88.929477
      }
    },
    "51ee5b3a-4e4b-4ca3-9d74-ad82c4992ce0": {
      "_southWest": {
        "lat": 23.875017,
        "lng": 77.097082
      },
      "_northEast": {
        "lat": 30.406857,
        "lng": 84.638873
      }
    },
    "f0fc0253-00ee-4425-a4c1-2a9f54ee8478": {
      "_southWest": {
        "lat": 28.709556,
        "lng": 77.575402
      },
      "_northEast": {
        "lat": 31.467234,
        "lng": 81.04296
      }
    },
    "8d551478-2528-4fa2-b57d-fef127414b14": {
      "_southWest": {
        "lat": 21.542499,
        "lng": 85.837664
      },
      "_northEast": {
        "lat": 27.216439,
        "lng": 89.862324
      }
    },
    "f578edd3-d12c-49a0-a63b-32975eb2d5c6": {
      "_southWest": {
        "lat": 20.051851,
        "lng": 72.911483
      },
      "_northEast": {
        "lat": 20.333587,
        "lng": 73.218134
      }
    },
    "60ed9a72-fb10-4d52-a7a1-8ae413125390": {
      "_southWest": {
        "lat": 20.372146,
        "lng": 70.873476
      },
      "_northEast": {
        "lat": 20.738504,
        "lng": 72.893544
      }
    },
    "0a86249d-a93c-4fc5-b396-93b91a8a2efc": {
      "_southWest": {
        "lat": 14.752028,
        "lng": 73.675734
      },
      "_northEast": {
        "lat": 15.781276,
        "lng": 74.335602
      }
    },
    "91220b18-e7bb-4b27-82bc-496fe0d887e2": {
      "_southWest": {
        "lat": 11.582378,
        "lng": 74.050962
      },
      "_northEast": {
        "lat": 18.476736,
        "lng": 78.588295
      }
    },
    "5c372a24-576e-4429-bce7-8d6244247ef8": {
      "_southWest": {
        "lat": 8.291356,
        "lng": 74.863038
      },
      "_northEast": {
        "lat": 12.794739,
        "lng": 77.412687
      }
    },
    "5f625567-29ec-44bc-96c8-7a174ee26f39": {
      "_southWest": {
        "lat": 10.827004,
        "lng": 75.528331
      },
      "_northEast": {
        "lat": 16.738977,
        "lng": 82.312359
      }
    },
    "69c25f05-9948-4aff-b1c4-756f0f0828fb": {
      "_southWest": {
        "lat": 8.077848,
        "lng": 76.233101
      },
      "_northEast": {
        "lat": 13.563153,
        "lng": 80.346305
      }
    },
    "dce3179e-b6c4-4725-9f04-80dccf51e755": {
      "_southWest": {
        "lat": 8.270073,
        "lng": 71.761025
      },
      "_northEast": {
        "lat": 12.403151,
        "lng": 74.10131
      }
    },
    "da54f44f-c15e-40ac-92c5-aaeb41696990": {
      "_southWest": {
        "lat": 17.372604,
        "lng": 80.852178
      },
      "_northEast": {
        "lat": 17.901425,
        "lng": 81.790972
      }
    },
    "6798982f-9d0f-4895-92be-b3e68479677e": {
      "_southWest": {
        "lat": 26.679843,
        "lng": 91.549499
      },
      "_northEast": {
        "lat": 29.459624,
        "lng": 97.415292
      }
    },
    "6ab6f7b3-be73-4c8f-af27-3fc3a9103fa0": {
      "_southWest": {
        "lat": 23.846764,
        "lng": 92.975278
      },
      "_northEast": {
        "lat": 25.691585,
        "lng": 94.74357
      }
    },
    "3b436c52-1f5a-4b4b-a055-483d9829080c": {
      "_southWest": {
        "lat": 21.94419,
        "lng": 92.258907
      },
      "_northEast": {
        "lat": 24.518164,
        "lng": 93.442632
      }
    },
    "789f14c7-f026-4c8b-9ee4-7c6e7236b301": {
      "_southWest": {
        "lat": 25.20196,
        "lng": 93.331832
      },
      "_northEast": {
        "lat": 27.03716,
        "lng": 95.237296
      }
    },
    "1246e09f-6ea0-444b-8c06-576526f63363": {
      "_southWest": {
        "lat": 22.944421,
        "lng": 91.154841
      },
      "_northEast": {
        "lat": 24.524657,
        "lng": 92.336558
      }
    },
    "be35e01f-5c99-46fe-a226-1caccca5504e": {
      "_southWest": {
        "lat": 6.755954,
        "lng": 92.214597
      },
      "_northEast": {
        "lat": 13.675174,
        "lng": 94.275765
      }
    }
}
//{key:'Cropwater',value:'Cropwater'},{key:'Groundwater',value:'Groundwater'},{key:'Rainfall',value:'Rainfall'},{key:'Recharge',value:'Recharge'},{key:'Draft',value:'Draft'},{key:'BasicData',value:'BasicData'},{key:'OtherResources',value:'Other Resources'},{key:'Flux',value:'Flux'}
SHEETMAPPING = {
  "BasicData" : {0:'Basic Data',1:'Aquifer Data'},
  'OtherResources' : {0:'Additional Potential Resources'},
  'Cropwater' : {0:'Crop Water Requirement'},
  'Groundwater' : {0:'Groundwater Well History Data',1:'GW Station Data',2:'GW TimeSeries Data'},
  'Flux' : {0:'Aquifer Base Flow',1:'Vertical Inter Aquifer Flow Data',2:'Lateral Aquifer Flow Data',3:'Evapotranspiration'},
  'Rainfall':{0:'Assessment Unit',1:'Rain Gauge Level',2:'IMD Grid',3:'Time Series'},
  'Recharge' : {0:'Surface Water Irrigation',1:'Canals',2:'Tanks & Ponds',3:'Artificial Structures',4:'Stream Recharges',5:'GW Irrigation Recharges'},
  'Draft' : {0:'Domestic Unit Draft',1:'Domestic Consumptive Use',2:'Industrial Unit Draft',3:'Industrial Consumptive Use Pattern',4:'Irrigation Unit Draft',5:'Irrigation Power Consumption'}, 
};
FORMINPUTMAPPING = [
  {
    name : "Basic",
    list:[{name:'Basic Data',class:"",sheetName:11},{name:'Aquifer Data',class:"",sheetName:12}],
    class:"active",
    innerClass:"show"
  },
  {
    name : "Draft",
    list:[{name:'Unit Draft',class:"",sheetName:31}, {name:'Industrial Consumptive Use Pattern',class:"",sheetName:34}, {name:'Domestic Consumptive Use',class:"",sheetName:32}, {name:' Irrigation Power Consumption',class:"",sheetName:36}],
    class:"",
    innerClass:""
  },
  {
    name : "Recharge",
    list:[
      {name:'SWI Canal Outlets',class:"",sheetName:81},
      {name:'SWI Crop Water Requirement',class:"",sheetName:82}, {name:'Canals',class:"",sheetName:83}, {name:'Tanks & Ponds',class:"",sheetName:84},{name:'Water Conservation Structures',class:"",sheetName:85},{name:'Stream Recharge',class:"",sheetName:86},
      {name:'Ground Water Irrigation',class:"",sheetName:87}
    ],
    class:"",
    innerClass:""
  },
  {
    name : "Resultant Flows",
    list:[{name:'Base Flows', class:"",sheetName:41},{name:'Vertical Flows', class:"",sheetName:42}, {name:'Lateral Flows', class:"",sheetName:43},{name:'Evaporation', class:"",sheetName:44},{name:'Transpiration', class:"",sheetName:45},{name:'Evapo Transpiration', class:"",sheetName:46}],
    class:"",
    innerClass:""
  },
  // {
  //   name : "Rainfall",
  //   list:[{name:'Assessment Unit', class:"",sheetName:71}],
  //   class:"",
  //   innerClass:""
  // },
  {
  name : "Other Resources",
  list:[{name:'Additional Potential', class:"",sheetName:61}, {name:'Confined Aquifer', class:"",sheetName:62},{name:'Semi-Confined Aquifer', class:"",sheetName:62}],
  class:"",
  innerClass:""
  },
  {
    name : "Quality Tagging",
    list:[{name:'Quality Tagging', class:"",sheetName:101}],
    class:"",
    innerClass:""
  },
  // 'OtherResources' : {0:'Additional Potential Resources'},
  // 'Cropwater' : {0:'Crop Water Requirement'},
  // 'Groundwater' : {0:'Groundwater Well History Data',1:'GW Station Data',2:'GW TimeSeries Data'},
  // 'Flux' : {0:'Aquifer Base Flow',1:'Vertical Inter Aquifer Flow Data',2:'Lateral Aquifer Flow Data',3:'Evapotranspiration'},
  // 'Rainfall':{0:'Assessment Unit',1:'Rain Gauge Level',2:'IMD Grid',3:'Time Series'},
  // 'Recharge' : {0:'Surface Water Irrigation',1:'Canals',2:'Tanks & Ponds',3:'Artificial Structures',4:'Stream Recharges',5:'GW Irrigation Recharges'},
  // 'Draft' : {0:'Domestic Unit Draft',1:'Domestic Consumptive Use',2:'Industrial Unit Draft',3:'Industrial Consumptive Use Pattern',4:'Irrigation Unit Draft',5:'Irrigation Power Consumption'}, 
];
SHEETEXCULDEROWS = {
  'Basic data' : 11,
  'Aquifer data' : 11
}

PRINCIPAL_AQUIFER = [
  {id:'AL',value:'Alluvium'},
  {id:'LT',value:'Laterite'},
  {id:'BS',value:'Basalt'},
  {id:'ST',value:'Sandstone'},
  {id:'SH',value:'Shale'},
  {id:'LS',value:'Limestone'},
  {id:'GR',value:'Granite'},
  {id:'SC',value:'Schist'},
  {id:'QZ',value:'Quartzite'},
  {id:'CK',value:'Charnockite'},
  {id:'KH',value:'Khondalite'},
  {id:'BG',value:'Banded Gneissic'},
  {id:'GN',value:'Gneiss'},
  {id:'IN',value:'Intrusive'}
];

MAJOR_AQUIFER = {
  'Alluvium':[
      {id:'AL01',value:'Younger Alluvium'},
      {id:'AL02',value:'Pebble / Gravel/ Bazada/ Kandi'},
      {id:'AL03',value:'Older Alluvium'},
      {id:'AL04',value:'Aeolian Alluvium'},
      {id:'AL05',value:'Coastal Alluvium'},
      {id:'AL06',value:'Valley Fills'},
      {id:'AL07',value:'Glacial Deposits'},
  ],
  'Laterite':[
      {id:'LT01',value:'Laterite / Ferruginous concretions'},
  ],
  'Basalt':[
      {id:'BS01',value:'Basic Rocks'},
      {id:'BS02',value:'Ultra-Basic'},
  ],
  'Sandstone':[
      {id:'ST01',value:'Sandstone/Conglomerate'},
      {id:'ST02',value:'Sandstone with Shale'},
      {id:'ST03',value:'Sandstone with Shale/ Coal beds'},
      {id:'ST04',value:'Sandstone with Clay'},
      {id:'ST05',value:'Sandstone/Conglomerate'},
      {id:'ST06',value:'Sandstone with Shale'},
  ],
  'Shale':[
      {id:'SH01',value:'Shale with Limestone'},
      {id:'SH02',value:'Shale with Sandstone'},
      {id:'SH03',value:'Shale, Limestone and Sandstone'},
      {id:'SH04',value:'Shale'},
      {id:'SH05',value:'Shale/Shale with Sandstone'},
      {id:'SH06',value:'Shale with Limestone'}, 
  ],
  'Limestone':[
      {id:'LS01',value:'Miliolitic Limestone'},
      {id:'LS02',value:'Limestone / Dolomite'},
      {id:'LS03',value:'Limestone/Dolomite'},
      {id:'LS04',value:'Limestone with Shale'},
      {id:'LS05',value:'Marble'}, 
  ],
  'Granite':[
      {id:'GR01',value:'Acidic Rocks'},
      {id:'GR02',value:'Acidic Rocks'},
  ],
  'Schist':[
      {id:'SC01',value:'Schist'},
      {id:'SC02',value:'Phyllite'},
      {id:'SC03',value:'Slate'},
  ],
  'Quartzite':[
      {id:'QZ01',value:'Quartzite'},
      {id:'QZ02',value:'Quartzite'},
  ],
  'Charnockite':[
      {id:'CK01',value:'Charnockite'},
  ],
  'Khondalite':[
      {id:'KH01',value:'Khondalite, Granulite'},
  ],
  'Banded Gneissic':[
      {id:'BG01',value:'Banded Gneissic Complex'},
  ],
  'Gneiss':[
      {id:'GN01',value:'Undifferentiated metasedimentaries/ Undifferentiated metamorphic'},
      {id:'GN02',value:'Gneiss'},
      {id:'GN03',value:'Migmatitic Gneiss'},
  ],
  'Intrusive':[
      {id:'IN01',value:'Basic Rocks'},
      {id:'IN02',value:'Ultra-Basics'},
  ],

}
DYNAMIC_INDICATOR_LIST = {
  "nallalabel" : "Number of Nalla's in the district flowing into tributaries or Ganga directly",
  "springlabel" : "Spring Rejuvenation",
  "wetlandlabel": "Wetland conservation",
  "riverlabel" :  "Small River rejuvenation",
  "industrylabel" : "List of Gross Polluting Industries (GPI)",
   "nonlabelind" : "Action taken against non-compliant Industries",
   "nallalabeldata": "Tapping of Nalla's",
   "percentlabel" : "Percentage of work completed for new STPs under construction",
   "reusagelabel" : "Reuse of treated waste water for different purposes mentioned below",
   "availabilitylabel" : "Availability of fecal sludge treatment plants",
   "stplabel" : "Are all STPs in the district operational"
}

}
